import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { rolePages, roleLabels } from '../config/rolePages';

function Sidebar({ activePage, setActivePage, onLogout }) {
  const { user } = useAuth();
  const role = user?.role || 'admin';
  const navItems = rolePages[role] || rolePages.admin;

  // Мобильное off-canvas меню: бургер открывает, overlay/выбор раздела закрывает.
  const [mobileOpen, setMobileOpen] = useState(false);

  // Блокируем скролл body когда меню открыто на мобильном.
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const handleNavClick = (id) => {
    setActivePage(id);
    setMobileOpen(false);  // закрываем меню после выбора раздела
  };

  return (
    <>
      {/* Бургер — виден только на узких экранах (CSS .sidebar-burger) */}
      <button
        type="button"
        className="sidebar-burger"
        aria-label="Меню"
        aria-expanded={mobileOpen}
        onClick={() => setMobileOpen(open => !open)}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>

      {/* Затемнение фона за выехавшим меню */}
      <div
        className={`sidebar-overlay ${mobileOpen ? 'show' : ''}`}
        onClick={() => setMobileOpen(false)}
      />

      <aside className={`sidebar ${mobileOpen ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <img src="/logo/novaflo-logo-v2.svg?v=2" alt="NovaFlo" />
        </div>

        <div className="sidebar-user">
          <div className="sidebar-user-name">{user?.name}</div>
          <div className="sidebar-user-role">{roleLabels[role] || role}</div>
        </div>

        <nav className="sidebar-nav">
          {navItems.map(item => (
            <div
              key={item.id}
              className={`nav-item ${activePage === item.id ? 'active' : ''}`}
              onClick={() => handleNavClick(item.id)}
            >
              {item.iconSrc ? (
                <img src={item.iconSrc} alt="" className="nav-item-icon" />
              ) : (
                <span>{item.icon}</span>
              )}
              <span>{item.label}</span>
            </div>
          ))}
        </nav>

        {/* «Выход» — вне прокручиваемого списка: на коротком экране (телефон, невысокое
            окно) пункты прокручиваются, а кнопка всегда видна внизу */}
        <button
          type="button"
          className="sidebar-logout"
          onClick={onLogout}
        >
          {/* inline SVG, чтобы stroke="currentColor" подхватил цвет текста (коралл/белый) */}
          <svg className="sidebar-logout-icon" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 17L21 12L16 7"/>
            <path d="M21 12H9"/>
            <path d="M13 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7"/>
          </svg>
          <span>Выход</span>
        </button>
      </aside>
    </>
  );
}

export default Sidebar;
